export default {
  SET_USER_MENUS_BREAD_CRUMB(state, params) {
    state.userMenus = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/common/breadCrumb/breadCrumbMutations.js